var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2966_1214)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.47673C0 1.10854 0.298477 0.810059 0.666667 0.810059H8.91667C9.28486 0.810059 9.58333 1.10854 9.58333 1.47673C9.58333 1.84492 9.28486 2.14339 8.91667 2.14339H0.666667C0.298477 2.14339 0 1.84492 0 1.47673ZM11 1.47673C11 1.10854 11.2985 0.810059 11.6667 0.810059H15.3333C15.7015 0.810059 16 1.10854 16 1.47673C16 1.84492 15.7015 2.14339 15.3333 2.14339H11.6667C11.2985 2.14339 11 1.84492 11 1.47673ZM0 6.06006C0 5.69187 0.298477 5.39339 0.666667 5.39339H4.33333C4.70152 5.39339 5 5.69187 5 6.06006C5 6.42825 4.70152 6.72673 4.33333 6.72673H0.666667C0.298477 6.72673 0 6.42825 0 6.06006ZM6.41667 6.06006C6.41667 5.69187 6.71514 5.39339 7.08333 5.39339H15.3333C15.7015 5.39339 16 5.69187 16 6.06006C16 6.42825 15.7015 6.72673 15.3333 6.72673H7.08333C6.71514 6.72673 6.41667 6.42825 6.41667 6.06006ZM0 10.6434C0 10.2752 0.298477 9.97672 0.666667 9.97672H8.91667C9.28486 9.97672 9.58333 10.2752 9.58333 10.6434C9.58333 11.0116 9.28486 11.3101 8.91667 11.3101H0.666667C0.298477 11.3101 0 11.0116 0 10.6434ZM11 10.6434C11 10.2752 11.2985 9.97672 11.6667 9.97672H15.3333C15.7015 9.97672 16 10.2752 16 10.6434C16 11.0116 15.7015 11.3101 15.3333 11.3101H11.6667C11.2985 11.3101 11 11.0116 11 10.6434ZM0 14.9767C0 14.6085 0.298477 14.3101 0.666667 14.3101H4.33333C4.70152 14.3101 5 14.6085 5 14.9767C5 15.3449 4.70152 15.6434 4.33333 15.6434H0.666667C0.298477 15.6434 0 15.3449 0 14.9767Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2966_1214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconText);
export default __webpack_public_path__ + "static/media/icon-text.6b485483d170b05afaaf0417378df041.svg";
export { ForwardRef as ReactComponent };